// import React, { useRef } from 'react';
// import Barcode from 'react-barcode';
// import { useSelector } from 'react-redux';
// import { useReactToPrint } from 'react-to-print';

// const PrintBarCode = () => {
//     const printingProducts = useSelector((state) => state.purchaseInvoice.printProducts);
//     const componentRef = useRef();

//     const generatePrint = useReactToPrint({
//         content: () => componentRef.current,
//         documentTitle: `Print Barcode`,
//     });

//     return (
//         <div className="bg-gray-100 min-h-screen p-4">
//             <div className="text-center mb-4">
//                 <h1 className="text-2xl font-semibold">Barcode Printing</h1>
//             </div>
//             <div className="mb-4">
//                 <div className="flex justify-center">
//                     <button className="btn btn-success text-white font-bold" onClick={generatePrint}>Print</button>
//                 </div>
//             </div>
//             <div ref={componentRef} className="flex flex-wrap justify-center items-center mt-16">
//                 {printingProducts.map((product, productIndex) => (
//                     Array.from({ length: product.quantity }).map((_, barcodeIndex) => (
//                         <div key={`${productIndex}`} className="w-2/12 my-2 mx-2 bg-white shadow-xl">
//                             <div style={{marginBottom:'-24px'}} className='text-center text-sm'>{product.name}</div>
//                             <div className='flex justify-center px-8'>
//                                 <Barcode value={product.code} />
//                             </div>
//                             <div style={{marginTop:'-26px'}} className='text-center text-sm'>{`${product?.remarks} ${product.sell}/-`}</div>
//                         </div>
//                     ))
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default PrintBarCode;

// import React, { useRef } from "react";
// import Barcode from "react-barcode";
// import { useSelector } from "react-redux";
// import { useReactToPrint } from "react-to-print";

// const PrintBarCode = () => {
//   const printingProducts = useSelector(
//     (state) => state.purchaseInvoice.printProducts
//   );

//   const componentRef = useRef();

//   const generatePrint = useReactToPrint({
//     content: () => componentRef.current,
//     documentTitle: "Print Barcode",
//   });

//   return (
//     <div style={{ background: "#f3f4f6", padding: 8 }}>
//       <div style={{ textAlign: "center", marginBottom: 12 }}>
//         <h1 style={{ fontSize: 18 }}>Barcode Printing</h1>
//       </div>

//       <div style={{ textAlign: "center", marginBottom: 12 }}>
//         <button
//           onClick={generatePrint}
//           style={{
//             background: "#16a34a",
//             color: "white",
//             padding: "8px 14px",
//             border: "none",
//             borderRadius: 4,
//             cursor: "pointer",
//           }}
//         >
//           Print
//         </button>
//       </div>

//       {/* Labels container */}
//       <div
//         ref={componentRef}
//         className="labels-container"
//         style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
//       >
//         {printingProducts.map((product, productIndex) =>
//           Array.from({ length: product.quantity }).map((_, barcodeIndex) => (
//             <div
//               key={`${productIndex}-${barcodeIndex}`}
//               className="barcode-label"
//               style={{
//                 width: "1.5in",
//                 height: "1in",
//                 boxSizing: "border-box",
//                 padding: "2px 4px", // less padding overall
//                 margin: "0",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between", // evenly space content
//                 alignItems: "center",
//                 background: "#fff",
//                 overflow: "hidden",
//               }}
//             >
//               {/* Brand name (top) */}
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                   fontFamily: "Arial, sans-serif",
//                   lineHeight: "1",
//                 }}
//               >
//                 Rupkotha
//               </div>

//               {/* Product name (wrap if long) */}
//               <div
//                 className="product-name"
//                 style={{
//                   fontSize: 13,
//                   lineHeight: "1.1",
//                   width: "100%",
//                   textAlign: "center",
//                   fontFamily: "Arial, sans-serif",
//                   marginTop: 1,
//                   whiteSpace: "normal",
//                   wordWrap: "break-word",
//                 }}
//               >
//                 {product.code} - {product.name}
//               </div>

//               {/* Barcode */}
//               <div
//                 className="barcode-wrapper"
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flex: 1,
//                   padding: "0", // tighter
//                 }}
//               >
//                 <Barcode
//                   value={product.code}
//                   displayValue={false}
//                   renderer="svg"
//                   width={2.2}
//                   height={34}
//                 />
//               </div>

//               {/* Price (bottom, very little margin) */}
//               <div
//                 className="product-code"
//                 style={{
//                   fontSize: 14,
//                   fontWeight: "bold",
//                   lineHeight: "1",
//                   textAlign: "center",
//                   fontFamily: "Arial, sans-serif",
//                   margin: 0, // remove bottom space
//                 }}
//               >
//                 {`${product?.remarks ?? ""} TK ${product?.sell}/-`}
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       <style>{`
//         .barcode-label svg {
//           width: 100% !important;
//           height: auto !important;
//           max-height: calc(1in - 30px);
//           display: block;
//         }
//         .barcode-label {
//           break-inside: avoid;
//           page-break-inside: avoid;
//         }
//         @media print {
//           html, body {
//             margin: 0;
//             padding: 0;
//             -webkit-print-color-adjust: exact;
//           }
//           .barcode-label {
//             margin: 0 !important;
//             border: none !important;
//             padding: 2px 4px !important;
//           }
//           @page {
//             size: 1.5in auto;
//             margin: 0;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default PrintBarCode;



import React, { useRef } from "react";
import Barcode from "react-barcode";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";

const PrintBarCode = () => {
  const printingProducts = useSelector(
    (state) => state.purchaseInvoice.printProducts
  );

  const componentRef = useRef();

  const generatePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Print Barcode",
  });

  return (
    <div style={{ background: "#f3f4f6", padding: 8 }}>
      <div style={{ textAlign: "center", marginBottom: 12 }}>
        <h1 style={{ fontSize: 18 }}>Barcode Printing</h1>
      </div>

      <div style={{ textAlign: "center", marginBottom: 12 }}>
        <button
          onClick={generatePrint}
          style={{
            background: "#16a34a",
            color: "white",
            padding: "8px 14px",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          Print
        </button>
      </div>

      {/* Labels container */}
      <div
        ref={componentRef}
        className="labels-container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {printingProducts.map((product, productIndex) =>
          Array.from({ length: product.quantity }).map((_, barcodeIndex) => (
            <div
              key={`${productIndex}-${barcodeIndex}`}
              className="barcode-label"
              style={{
                width: "1.5in",
                height: "1in",
                boxSizing: "border-box",
                padding: "2px 3px",
                margin: "0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              {/* Top text (brand + product) */}
              <div
                style={{
                  fontSize: 11,
                  fontWeight: "bold",
                  textAlign: "center",
                  fontFamily: "Arial, sans-serif",
                  lineHeight: "1",
                  marginBottom: 1,
                }}
              >
                Rupkotha
              </div>

              <div
                className="product-name"
                style={{
                  fontSize: 12,
                  lineHeight: "1",
                  width: "100%",
                  textAlign: "center",
                  fontFamily: "Arial, sans-serif",
                  marginBottom: 1,
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
              >
                {product.code} - {product.name}
              </div>

              {/* Barcode */}
              <div
                className="barcode-wrapper"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flex: 1,
                  margin: "1px 0",
                }}
              >
                <Barcode
                  value={product.code}
                  displayValue={false}
                  renderer="svg"
                  width={2}
                  height={30}
                />
              </div>

              {/* Price (moved closer to barcode) */}
              <div
                className="product-code"
                style={{
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: "1",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    marginTop: 0,
    marginBottom: 2, // 👈 added bottom margin
  }}
              >
                {`${product?.remarks ?? ""} TK ${product?.sell}/-`}
              </div>
            </div>
          ))
        )}
      </div>

      <style>{`
  .barcode-label svg {
    width: 100% !important;
    height: auto !important;
    max-height: calc(1in - 28px);
    display: block;
  }
  .barcode-label {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .product-code {
    margin-bottom: 2px !important; /* ✅ force bottom margin */
  }
  @media print {
    html, body {
      margin: 0;
      padding: 0;
      -webkit-print-color-adjust: exact;
    }
    .barcode-label {
      margin: 0 !important;
      border: none !important;
      padding: 2px 3px !important;
    }
    .product-code {
      margin-bottom: 2px !important; /* ✅ also inside print */
    }
    @page {
      size: 1.5in auto;
      margin: 0;
    }
  }
`}</style>

    </div>
  );
};

export default PrintBarCode;












// mport React, { useRef, useState } from 'react';
// import Barcode from 'react-barcode';
// import { useSelector } from 'react-redux';
// import { useReactToPrint } from 'react-to-print';

// const PrintBarCode = () => {
//     const [barcodeValue, setBarcodeValue] = useState('');
//     const [quantity, setQuantity] = useState(1);
//     const printingProducts = useSelector((state) => state.purchaseInvoice.printProducts);
//     const componentRef = useRef();

//     console.log(printingProducts);

//     const products = [
//         { name: "Product A", code: "2023760", quantity: 5 },
//         { name: "Product B", code: "2023761", quantity: 3 },
//         { name: "Product C", code: "2023762", quantity: 2 },
//     ];

//     const handleInputChange = (e) => {
//         setBarcodeValue(e.target.value);
//     };

//     const handleQuantityChange = (e) => {
//         setQuantity(e.target.value);
//     };

//     const generatePrint = useReactToPrint({
//         content: () => componentRef.current,
//         documentTitle: `Print Barcode`,
//     })

//     return (
//         <>
//         {/* // <div className="bg-gray-100 min-h-screen p-4"> */}
//                 {/* <h1 className="text-2xl font-semibold mb-4">Barcode Printing</h1>
//             <div className="mb-4">
//                 <label className="block text-gray-700">Enter Barcode Value:</label>
//                 <input
//                     type="text"
//                     className="border rounded-md p-2 w-full"
//                     value={barcodeValue}
//                     onChange={handleInputChange}
//                 />
//             </div>
//             <div className="mb-4">
//                 <label className="block text-gray-700">Quantity:</label>
//                 <input
//                     type="number"
//                     className="border rounded-md p-2 w-full"
//                     value={quantity}
//                     onChange={handleQuantityChange}
//                 />
//             </div> */}
//                 <div className='w-full mt-16 mx-auto'>
//                 <div className='text-right'>
//                     <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
//                 </div>
//                 <div ref={componentRef} className="flex flex-wrap justify-center items-center mt-16">
//                     {printingProducts.map((product, productIndex) => (
//                         Array.from({ length: product.quantity }).map((_, barcodeIndex) => (
//                             <div key={`${productIndex}-${barcodeIndex}`} className="w-2/12 my-2 mx-2 bg-white shadow-xl">
//                                 <div style={{ marginBottom: '-28px' }} className='shadow-2xl bg-white w-full mx-auto'>{product.name}</div>
//                                 <div className='px-8' style={{ display: 'flex', justifyContent: 'center', margin: '0' }}>
//                                     <Barcode className='shadow-xl' value={product.code} />
//                                 </div>
//                                 <div style={{ marginTop: '-28px' }} className='shadow-xl bg-white w-full mx-auto'>{`${product?.remarks} ${product.sell}/-`}</div>
//                             </div>
//                         ))
//                     ))}
//                 </div>
//                 </div>
//         </>
//     );
// };

// export default PrintBarCode;
